import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CoreDynamicFormService } from '../../providers/services/dynamic-form.service';
import { Constants, ERRORS } from '../../models/constants';
import { throwError } from 'rxjs';
import { CoreCommonService } from '../../providers/services/common.service';
// import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { CoreHttpService } from '../../utilities/services/http.service';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html'
})

export class DynamicFormComponent implements OnChanges {
  @Input() schema: any;
  @Input() scope: any;
  @Output() formGroupCopy = new EventEmitter<FormGroup>();
  fields = [];
  fieldCounter = 0;
  pdfData: any;

  formGroup: FormGroup;
  constructor(private dynamicFormService: CoreDynamicFormService,
    private coreCommonService: CoreCommonService,
    private coreHttpService: CoreHttpService, @Inject('ENV_CONFIG') public environment: any) { }

  /**
   * A callback method that is invoked if any data-bound properties change
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes?.schema && changes.schema?.currentValue) {
      this.initForm();
    }
  }

  /**
   * This method will initialize the form
   */
  private async initForm() {
    try {
      this.resetVariables();
      this.fields = this.extractControlsFromSchema(this.schema);
      if (this.fields.length > 0) { this.generateForm(this.fields); }
      // TODO: Access formlayout as online / backoffice based on flag. hardcoded temporarily
      if (this.schema.formLayoutType.online === Constants.formSchemaType.doubleColumnSchema) {
        this.pdfData = await this.extractImageFromSchema(this.schema);
      }
    } catch (error) { console.log(`${ERRORS.FORM_INIT_FAILED} : ${error}`); }
  }

  /**
   * This method will generate form
   */
  private async generateForm(fields: Array<any>) {
    this.formGroup = await this.dynamicFormService.toFormGroup(this.fields, this, this.scope);
    return this.formGroup;
  }

  // INFO: Removed additional check for buttons to be displayed
  // get isFormNotEmpty() { return (this.formGroup && Object.keys(this.formGroup.controls).length > 0); }
  /**
   * getter function to check if form is empty
   */
  get isFormNotEmpty() { return this.formGroup !== undefined; }

  /**
   * check if control is ready or not
   */
  onControlReady() {
    this.fieldCounter++;
    if (this.fieldCounter === this.fields.length) { this.formGroupCopy.emit(this.formGroup); }
  }

  get layoutType() {
    return this.schema?.formLayoutType[this.environment.applicationType];
  }

  // ----------------------------- Supporting functions -------------------------

  /**
   * This method will extract controls from schema
   */
  private extractControlsFromSchema(schema: object): Array<any> {
    if (!schema) { return []; }
    const fields = schema.hasOwnProperty('controls') ? schema['controls'] : [];
    return fields;
  }

  get isButtonField() {
    return this.schema.hasOwnProperty('controls') && Constants.BUTTON_CONTROLS_LIST.indexOf(this.schema.controls[0]?.bundleName) > -1;
  }

  /**
   * This method will reset variables
   */
  private resetVariables(): boolean {
    this.fields = [];
    this.fieldCounter = 0;
    this.pdfData = null;
    return true;
  }

  /**
   * This method will extract images from schema
   * @param schema - schema
   */
  private async extractImageFromSchema(schema: object) {
    try {
      const controls: Array<any> = schema.hasOwnProperty('controls') ? schema['controls'] : [];
      const imageField = await this.coreCommonService.extractFieldOfType(Constants.controls.Image, controls);
      const field = imageField.hasOwnProperty('fields') ? imageField['fields'][0] : null;
      if (field) {
        try {
          const apiObj = this.coreCommonService.extractApiAsPerDomain(field['optionsListApi']);
          let data: Array<any>;
          if (apiObj['params'] && Array.isArray(apiObj['params']) && apiObj['params'].length > 0) {
            const params = new HttpParams({ fromObject: this.coreCommonService.extractAndConstructParams(apiObj['params']) });
            data = await this.coreHttpService.doGet(apiObj['url'], params)
              .toPromise().then(val => val).catch(error => { throw error; });
          } else { data = await this.coreHttpService.doGet(apiObj['url']).toPromise().then(val => val).catch(error => { throw error; }); }

          return data;
        } catch (error) { console.log(error); }
      }
    } catch (error) { throwError(error); }
  }

  /**
   * The trackBy function takes the index and the current item as arguments
   * and needs to return the unique identifier for this item
   * @param index - item index
   */
  trackByFn(index: number, item): number {
    if (!item) { return null; }
    return index;
  }
}
